module.exports = __webpack_public_path__ + "img/26.4e61a402.jpg";